import { store } from '../index'

function setLanguageAct(language) {
    return {
        type: "SET_LANGUAGE",
        language
    }
}

export const setLanguage = (language) => {
    return store.dispatch(setLanguageAct(language))

}